import { useOutletContext } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import DateInput from "../components/DatePicker";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import TableLoader from "../components/Spinner/TableLoader";
import { Modal, Button } from "react-bootstrap";
import { notifyError } from "../components/notify";
import ExpandableTextMobile from "../components/ExpandableText";
import {
  BASE_MOBILE_API_URL,
  BASIC_AUTH,
  formatDateForDatabase,
  formatMonthDate,
} from "../constants";
import axios from "axios";

const PurchaseHistory = () => {
  const currentDate = new Date();
  const { setPageTitle } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [sendQRModal, setSendQRModal] = useState(false);
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");

  useEffect(() => {
    setPageTitle("Purchase History");
  }, [setPageTitle]);

  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const [filteredData, setFilteredData] = useState({
    sales_header: [],
    sales_details: [],
  });
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const mobileRef = useRef(null);

  useEffect(() => {
    if (sendQRModal && mobileRef.current) {
      mobileRef.current.focus();
    }
  }, [sendQRModal]);

  const handleFilter = async (e) => {
    e.preventDefault();
    if (!fromDate) {
      notifyError("Please select from date.");
      return;
    } else if (!toDate) {
      notifyError("Please select to date.");
      return;
    } else if (fromDate > toDate) {
      notifyError("From date cannot be greater than To date.");
      return;
    }
    setLoading(true);

    let formattedFromDate = formatDateForDatabase(fromDate);
    let formattedToDate = formatDateForDatabase(toDate);
    try {
      const response = await axios.get(`${BASE_MOBILE_API_URL}/get_sale_data`, {
        params: {
          companycode: customer?.companycode,
          from_date: formattedFromDate,
          to_date: formattedToDate,
          supervisorcode: customer?.customercode,
          branchcode: customer?.branchcode,
          callfrom: "C",
        },
        headers: {
          Authorization: BASIC_AUTH,
        },
      });

      const result = response.data;
      setFilteredData(result);
    } catch (err) {
      console.error(err);

      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Fatch purchase history failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  const totalPcs = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.noofitem),
    0
  );

  const totalQty = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.qty),
    0
  );

  const totalAmount = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.amount),
    0
  );

  return (
    <>
      <div className="col-12  d-lg-flex d-block pt-3 px-2 g-2 align-items-center">
        {/* From Date */}
        <div className="col-12 col-lg-5 d-lg-flex d-block d-md-flex">
          <label className="col-12 col-lg-5 col-md-6 text-sm text-theme fw-bold mt-1">
            Select From Date <span className="red-error">*</span>
          </label>
          <div className="col-12 col-lg-6 col-md-6">
            <DateInput
              selected={fromDate}
              onChange={setFromDate}
              defaultMonth={fromDate || new Date()}
            />
          </div>
        </div>

        {/* To Date */}
        <div className="col-12 col-lg-3  mt-2 mt-lg-0 d-lg-flex d-md-flex d-block">
          <label className="col-12 col-md-6 col-lg-4 text-sm text-theme fw-bold mt-1">
            To Date <span className="red-error">*</span>
          </label>
          <div className="col-12 col-md-6 col-lg-8">
            <DateInput
              selected={toDate}
              onChange={setToDate}
              defaultMonth={toDate || new Date()}
            />
          </div>
        </div>

        {/* Proceed Button */}
        <div className="col-11 col-md-6 col-lg-3 d-flex align-items-center justify-content-lg-center justify-content-start mt-2 mt-lg-0">
          <ButtonSpinner
            type="submit"
            className="col-md-7 col-lg-9 col-7  btn-theme btn-md text-black"
            loading={loading}
            onClick={handleFilter}
          >
            <b>{loading ? "Proceeding..." : "Proceed"}</b>
          </ButtonSpinner>
        </div>
      </div>
      <hr className="text-white" />
      <div className="d-flex flex-column align-items-center">
        {loading ? (
          <TableLoader
            message={`Loading purchase data...`}
            size="sm"
            messageClass="tablemessage-white"
            spinnerClass="tablespinner-white"
          />
        ) : (
          <>
            {filteredData.sales_header?.length > 0 &&
              filteredData.sales_header.map((header, index) => {
                // Get details for this header
                const orderDetails = filteredData.sales_details.filter(
                  (detail) => detail.saleheadercode === header.saleheadercode
                );

                return (
                  <div key={index} className="col-12 col-md-8 mb-2 px-1">
                    <div
                      className="card purchase-card shadow-sm"
                      onClick={(e) => {
                        //  If clicked element is inside long-text → do nothing
                        if (e.target.closest(".long-remark-text")) {
                          return;
                        }
                        if (orderDetails.length > 0) {
                          setSelectedOrder({
                            header: header,
                            details: orderDetails,
                          });
                          setShowModal(true);
                        } else {
                          notifyError("Items are not present for this order.");
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="card-body p-md-3 p-lg-3 p-2 ">
                        {/* Top Row */}
                        <div className="d-flex justify-content-between purchase-info fw-600 px-1">
                          <div>
                            <div>Bill No : {header.saleheadercode}</div>
                          </div>

                          <div className="text-md-end text-lg-end">
                            <div>
                              {" "}
                              {formatMonthDate(header.entrydate)} |{" "}
                              {header.entrytime}
                            </div>
                          </div>
                        </div>

                        <hr />

                        {/* Amount Section */}
                        <div className="col-12 d-flex  align-items-center fw-600 font-15">
                          {/* LEFT - Total */}
                          <div className="col-6 text-start">
                            <div> {header.totalitem} Items</div>
                            <div
                              style={{
                                color:
                                  header.orderamount > 0 ? "green" : "black",
                              }}
                            >
                              Paid : ₹ {header.orderamount}
                            </div>
                          </div>

                          {/* RIGHT - Paid & Balance */}
                          <div className="col-6 text-end">
                            <div> Total : ₹ {header.totalamount}</div>

                            <div
                              style={{
                                color:
                                  header.remainingamount > 0 ? "red" : "black",
                              }}
                            >
                              Balance : ₹ {header.remainingamount}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            {filteredData.sales_header?.length > 0 && (
              <div className="col-12 d-flex justify-content-center sticky-total-bar py-1">
                Total Amount : ₹{" "}
                {filteredData.sales_header
                  .reduce((sum, header) => sum + header.totalamount, 0)
                  .toFixed(2)}
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Order Detail</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedOrder && (
              <>
                {/* Order Info */}
                <div className="row mb-3 fw-bold">
                  <div className="col-12 d-flex  justify-content-between">
                    <div>Bill No : {selectedOrder.header.saleheadercode}</div>
                    <div className="mb-1 d-none d-md-flex">
                      Date : {formatMonthDate(selectedOrder.header.entrydate)} |{" "}
                      {selectedOrder.header.entrytime}
                    </div>
                    <div>
                      <span className="bg-white text-success px-2 py-1 mt-1 rounded">
                        Total : ₹ {selectedOrder.header.totalamount}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12  d-flex  justify-content-between d-md-none d-lg-none">
                    <div className="mb-1">
                      Date : {formatMonthDate(selectedOrder.header.entrydate)} |{" "}
                      {selectedOrder.header.entrytime}
                    </div>
                  </div>
                </div>

                {/* Items Table */}
                <div className="table-container">
                  <div className="table-responsive">
                    <table className="table table-dark table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th className="text-center">SR</th>
                          <th>Item</th>
                          <th className="text-center">PCS</th>
                          <th className="text-center">QTY</th>
                          <th className="text-end">Rate</th>
                          <th className="text-end">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder.details?.map((itm, i) => (
                          <tr key={i}>
                            <td className="text-center">{i + 1}</td>
                            <td>
                              <ExpandableTextMobile
                                text={`${itm.itemname}`}
                                className="long-text"
                              />
                            </td>
                            <td className="text-center no-wrap">
                              {itm.noofitem}
                            </td>
                            <td className="text-center no-wrap">{itm.qty}</td>
                            <td className="text-end no-wrap">{itm.rate}</td>
                            <td className="text-end no-wrap">{itm.amount}</td>
                          </tr>
                        ))}

                        <tr className="table-secondary fw-bold">
                          <td className="text-center">TOTAL</td>
                          <td></td>
                          <td className="text-center">{totalPcs}</td>
                          <td className="text-center">{totalQty}</td>
                          <td></td>
                          <td className="text-end no-wrap">
                            {totalAmount.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      <Modal
        show={sendQRModal}
        onHide={() => {
          setSendQRModal(false);
        }}
        backdrop="static"
        keyboard={false}
        onEntered={() => {
          setMobile("");
          setMobileError("");
          if (mobileRef.current) {
            mobileRef.current.focus();
          }
        }}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">
              Send Payment QR Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label small text-white fw-semibold">
                <i className="fa-solid fa-phone text-warning"></i> WhatsApp No.{" "}
                <span className="red-error">*</span>
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter whatsapp number"
                ref={mobileRef}
                value={mobile}
                onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                maxLength={10}
              />
              {mobileError && <p className="red-error">{mobileError}</p>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => {
                if (mobile) {
                  setSendQRModal(false);
                } else {
                  setMobileError("Please enter a valid mobile number.");
                }
              }}
              className="btn btn-success"
            >
              Send QR
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};
export default PurchaseHistory;
